// extracted by mini-css-extract-plugin
export var option = "_bk-0";
export var optionCard = "_bk-f";
export var optionContent = "_bk-g";
export var optionIcon = "_bk-i";
export var optionIconBox = "_bk-h";
export var optionLabel = "_bk-j";
export var optionPill = "_bk-m";
export var optionPillBadge = "_bk-p";
export var optionPillIcon = "_bk-n";
export var optionPillLabel = "_bk-o";
export var optionRadio = "_bk-k";
export var optionRadioInner = "_bk-l";
export var optionReveal = "_bk-2";
export var optionRevealDelay0 = "_bk-3";
export var optionRevealDelay1 = "_bk-4";
export var optionRevealDelay10 = "_bk-d";
export var optionRevealDelay11 = "_bk-e";
export var optionRevealDelay2 = "_bk-5";
export var optionRevealDelay3 = "_bk-6";
export var optionRevealDelay4 = "_bk-7";
export var optionRevealDelay5 = "_bk-8";
export var optionRevealDelay6 = "_bk-9";
export var optionRevealDelay7 = "_bk-a";
export var optionRevealDelay8 = "_bk-b";
export var optionRevealDelay9 = "_bk-c";
export var optionSelected = "_bk-1";